// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`BannerBoxes.vue when given isHalf: true,  should not render carousel 1`] = `
<div>
  <div
    class="flex gap-4 flex-col lg:flex lg:flex-row"
  >
    <bannerbox-stub
      backgroundcolor=""
      badgecolor="bg-EXPONDO-white"
      badgetext=""
      boxbackground=""
      buttontext="lorem button"
      buttontype="secondary"
      description="lorem ipsum lorem ipsum"
      hasbutton="true"
      header="lorem ipsum"
      iconclass=""
      image="https://www.expondo.co.uk/inspirations/wp-content/uploads/2023/01/microwaveable-dishes.jpg"
      link="/search?refinementList%5Bbrand%5D%5B0%5D=Fromm%20%26%20Starck"
      mobileimage=""
      strapbackground=""
      textcolor="text-EXPONDO-white"
    />
    <bannerbox-stub
      backgroundcolor=""
      badgecolor="bg-EXPONDO-white"
      badgetext=""
      boxbackground=""
      buttontext="lorem button"
      buttontype="secondary"
      description="lorem ipsum lorem ipsum 2"
      displaystrap="true"
      hasbutton="true"
      header="lorem ipsum 2"
      iconclass="iconify svg--facebook"
      image="https://www.expondo.co.uk/inspirations/wp-content/uploads/2023/01/microwaveable-dishes.jpg"
      link="/search?refinementList%5Bbrand%5D%5B0%5D=Fromm%20%26%20Starck"
      mobileimage=""
      strapbackground=""
      textcolor="text-EXPONDO-white"
    />
  </div>
   
  <!---->
</div>
`;

exports[`BannerBoxes.vue when two elements are provided,  prints two elements 1`] = `
<div>
  <div
    class="flex gap-4 hidden lg:grid grid-cols-[2fr_1fr]"
  >
    <bannerbox-stub
      backgroundcolor=""
      badgecolor="bg-EXPONDO-white"
      badgetext=""
      boxbackground=""
      buttontext="lorem button"
      buttontype="secondary"
      description="lorem ipsum lorem ipsum"
      hasbutton="true"
      header="lorem ipsum"
      iconclass=""
      image="https://www.expondo.co.uk/inspirations/wp-content/uploads/2023/01/microwaveable-dishes.jpg"
      link="/search?refinementList%5Bbrand%5D%5B0%5D=Fromm%20%26%20Starck"
      mobileimage=""
      strapbackground=""
      textcolor="text-EXPONDO-white"
    />
    <bannerbox-stub
      backgroundcolor=""
      badgecolor="bg-EXPONDO-white"
      badgetext=""
      boxbackground=""
      buttontext="lorem button"
      buttontype="secondary"
      description="lorem ipsum lorem ipsum 2"
      displaystrap="true"
      hasbutton="true"
      header="lorem ipsum 2"
      iconclass="iconify svg--facebook"
      image="https://www.expondo.co.uk/inspirations/wp-content/uploads/2023/01/microwaveable-dishes.jpg"
      link="/search?refinementList%5Bbrand%5D%5B0%5D=Fromm%20%26%20Starck"
      mobileimage=""
      strapbackground=""
      textcolor="text-EXPONDO-white"
    />
  </div>
   
  <div
    class="lg:hidden"
  >
    <simplecarousel-stub
      activeindex="0"
      fixedslidewidthvalue="0"
      gap="0"
      height="auto"
      nextarrowclass="right-0"
      perpage="1"
      prevarrowclass="left-0"
      showpaginationcontrols="true"
      slideclass="justify-center"
      slideritems="[object Object],[object Object]"
      wrapperclasses=""
    />
  </div>
</div>
`;

exports[`BannerBoxes.vue when zero elements are provided,  prints nothing 1`] = `
<div>
  <div
    class="flex gap-4 hidden lg:grid grid-cols-[2fr_1fr]"
  />
   
  <div
    class="lg:hidden"
  >
    <simplecarousel-stub
      activeindex="0"
      fixedslidewidthvalue="0"
      gap="0"
      height="auto"
      nextarrowclass="right-0"
      perpage="1"
      prevarrowclass="left-0"
      showpaginationcontrols="true"
      slideclass="justify-center"
      slideritems=""
      wrapperclasses=""
    />
  </div>
</div>
`;
